export const FF_OUTAGE_BANNER = 'we-transfer-outage-banner';

export const FF_PIXEL_TRACKING = 'marketing-pixel-tracking';

export const FF_ACCOUNT_STATE_FIELD = 'account-state-field';

export const FF_CROSS_PRODUCT_USAGE_SURVEY_UPSELL =
  'cross-product-usage-survey-upsell';

export const FF_DISABLE_SPLASHPAGE = 'disable-splashpage';

export const FF_BUNDLE_SPLASHPAGE_EXPERIMENT = 'bundle-splashpage-experiment';

export const FF_TEAMS_TRANSFER_ONBOARDING = 'teams-transfer-onboarding';

export const FF_ENSEMBLE = 'ensemble';

// The portals discovery flag has a dependency on the Ensemble flag
export const FF_UPDATED_TIER_PANEL = 'updated-tier-panel';

export const FF_RECIPIENT_SPLASH_PAGE = 'recipient-splash-page';

export const FF_DIRECT_STORM_UPLOAD = 'direct-storm-upload';

export const FF_PREMIUM_FOR_PRO_USERS = 'premium-for-pro-users';

// TRA-2593 Pro Panel Conversion Experiment
export const FF_PRO_PANEL_CONVERSION_EXPERIMENT =
  'pro-panel-conversion-experiment';

export const FF_REFERRAL_PROGRAM = 'referral-program';

export const FF_ALTERNATIVE_COPY_PRICING_PAGE_EXPERIMENT =
  'alternative-copy-pricing-page-experiment';

export const FF_TRANSFER_SIZE_TOOLTIP_EXPERIMENT =
  'transfer-size-tooltip-experiment';

export const FF_SHOW_PRICING_PAGE_TO_FA_EXPERIMENT =
  'show-pricing-page-to-free-account-experiment';

// variantA/variantB/variantC are available for this FF
export const FF_PRICING_CARDS_HIERARCHY_EXPERIMENT =
  'pricing-cards-hierarchy-multivariant';

export const FF_AUTOCOMPLETE_BILLING_DETAILS = 'autocomplete-billing-details';

export const FF_UPSELL_DESTINATION_EXPERIMENT =
  'pricing-panel-upsell-destination-experiment';

export const FF_FREE_ACCOUNT_SPLASH_EXPERIMENT =
  'free-account-users-splash-experiment';

// variant-a/variant-b/variant-c are available for this FF
export const FF_NAV_SIGN_UP_EXPERIMENT = 'nav-sign-up-label-experiment';

// variants: quick-pages, pay-to-download, advanced-receiving
export const FF_PUBLISH_SMOKE_TEST = 'publish-smoke-test';

export const FF_PUBLISH_SURVEY_PANEL = 'publish-survey-panel';

export const FF_ADS_ON_MOBILE_WEB = 'ads-on-transfer-mobile-web';

export const FF_AD_SDK_2 = 'ad-sdk-2-0';

// AMPLITUDE EXPERIMENTS
// All amplitude experiments should start with `exp-`

export const EXP_FREE_ACCOUNT_SPLASH = {
  key: 'exp-free-account-users-splash',
  default: 'Control',
  showPremiumCard: 'show-premium-card',
};

export const EXP_AD_BLOCK_LIBRARY_RELEASE = {
  key: 'exp-ad-blocking-library-release',
  default: 'control',
};

export const FF_ACTIVE_PLACEMENT_OPTIMIZATION = 'active-placement-optimization';

export const FF_WALLPAPER_ROTATION_INTERVAL_PER_COUNTRY =
  'wallpaper-rotation-intervals-per-country';

export const EXP_PRO_USER_EDITORIAL_EXCEPTION = {
  key: 'serve-ads-on-pro-users',
  default: 'control',
};

export const EXP_OPTIMIZE_FONT = {
  key: 'exp-optimize-font',
  default: 'control',
};
